/**
 * Translation keys duplicated from `@lumapps/translations` so that `base-api` does not depend on the
 * `translations` feature package (which would create a `scope:core` boundary violation and a dependency
 * cycle). These keys MUST stay in sync with their counterparts in `@lumapps/translations`.
 */
export enum GLOBAL {
    /**
     * @value An error occurred
     * @description used when displaying an generic error, normally displayed using a notification on the bottom right corner of the screen.
     */
    GENERIC_ERROR = 'GLOBAL.ERROR.GENERIC',
    /**
     * @value Not authorized
     * @description Not authorized generic error message
     */
    SERVER_ERROR_NOT_AUTHORIZED = 'SERVER_ERROR_NOT_AUTHORIZED',
}

/**
 * Maps a server error code to its translation key.
 * Mirrors `getServerError` from `@lumapps/translations`.
 */
export const getServerError = (serverError: string) => `SERVER_ERROR_${serverError}`;
